import axios from "axios";

const apiClient = axios.create({
  // baseURL: "https://sml-buyers-portal-stage.homeofpmg.com.au",
  baseURL: process.env.VUE_APP_API_URL ?? "api",
  withCredentials: true,
  auth: {
    username: process.env.VUE_APP_STAGE_USER,
    password: process.env.VUE_APP_STAGE_PASSWORD
  },
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

// Response interceptor
apiClient.interceptors.response.use(
  response => response,
  error => httpFail(error)
);

export { apiClient };

function httpFail(error) {
  // Reject on Laravel-driven validation errors
  if (error.response && error.response.status === 422) {
    return Promise.reject(error);
  }

  // Refresh page if CSRF token expired
  if (error.response && error.response.status === 419) {
    window.location.reload();
  }

  // Redirect to log in page if unauthenticated
  if (error.response && error.response.status === 401) {
    // window.$router.push("/login");
  }

  // Show all other errors
  return Promise.reject(error);
}

// LOAD AND EXPORT MODULES
import auth from "@/services/api/modules/auth";
import user from "@/services/api/modules/user";
import business from "@/services/api/modules/business";
import pass from "@/services/api/modules/pass";
import passTypes from "@/services/api/modules/passTypes";
import marketTours from "@/services/api/modules/marketTours";
import media from "@/services/api/modules/media";
import enquiry from "@/services/api/modules/enquiry";
import induction from "@/services/api/modules/induction";
import survey from "@/services/api/modules/survey";
import parkingPass from "@/services/api/modules/parkingPass";

export default {
  auth,
  user,
  business,
  pass,
  passTypes,
  marketTours,
  media,
  enquiry,
  induction,
  survey,
  parkingPass
};
